module.exports = __webpack_public_path__ + "img/icon_shebei@2x.14006302.png";